export default {
  name: 'marking--treeMrkCheckGisMtStatus',
  apiService: 'shoes',
  apiPath: '/admin/mrk/func/check_gis_mt',
  urlParamName: 'marking--treeMrkCheckGisMtStatus',
};
